import { CredentialEnum, IdentityRecord, IdentityType, makeIntoIdentity } from '@orgbrain/lib-data';
import { BaseUser } from './lib-admin';

export function getIdentityRecord(
  user: BaseUser,
  type: IdentityType | CredentialEnum
): IdentityRecord {
  type = makeIntoIdentity(type);
  const record: IdentityRecord =
    user.identities && user.identities.find((x) => x.identityType === type);
  return record;
}

export function getIdentityId(user: BaseUser, type: IdentityType | CredentialEnum): string {
  type = makeIntoIdentity(type);
  const record: IdentityRecord =
    user.identities && user.identities.find((x) => x.identityType === type);
  const id = record && record.identityId;
  return id ? id.toString() : null;
}

export function getIdentityId2(user: BaseUser, type: IdentityType | CredentialEnum): string {
  type = makeIntoIdentity(type);
  const record: IdentityRecord =
    user.identities && user.identities.find((x) => x.identityType === type);

  if (!record) {
    return undefined;
  }
  const id = record.identityId;
  return id ? id.toString() : null;
}

export function getIdentityStamp(user: BaseUser, type: IdentityType | CredentialEnum) {
  type = makeIntoIdentity(type);
  const record: IdentityRecord =
    user.identities && user.identities.find((x) => x.identityType === type);
  const stamp = record && record.stamp;
  return stamp;
}

export function getIdentityData(user: BaseUser, type: IdentityType | CredentialEnum) {
  type = makeIntoIdentity(type);
  const record: IdentityRecord =
    user.identities && user.identities.find((x) => x.identityType === type);
  const data = record && record.data;
  return data;
}
